import { render, staticRenderFns } from "./ServicePlan.vue?vue&type=template&id=53e5f652&scoped=true"
import script from "./ServicePlan.vue?vue&type=script&lang=js"
export * from "./ServicePlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e5f652",
  null
  
)

export default component.exports